import { Component, OnInit, ViewChild } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

import { LoggedActions } from '../../modelo/LoggedActions';

import { AuditoriaService } from '../auditoria.service';

import { UserService, User, UsersService } from "../../core";

import { catchError, map } from 'rxjs/operators';

import { Table } from 'primeng/table';
import { ConfirmationService, Message } from 'primeng/api';
import { MessageService } from 'primeng/api';

import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { environment } from 'src/environments/environment';

import jsPDF from "jspdf";
import "jspdf-autotable";

import { DatePipe } from '@angular/common';

import { Reporte } from 'src/app/modelo/Reporte';
import { FiltroData } from 'src/app/modelo/FiltroData';
import { FiltrosData } from 'src/app/modelo/FiltrosData';
import { AdministracionService } from 'src/app/administracion/administracion.service';
import { TareaModel } from 'src/app/modelo/Tarea.model';
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { UIService } from 'src/app/core/services/ui.service';
import { FAZILService } from 'src/app/core/services/fazil.service';

@Component({
    selector: 'app-auditoria-datatable',
    templateUrl: './auditoria-datatable.component.html',
    styleUrls: ['./auditoria-datatable.component.scss']
})
export class AuditoriaDatatableComponent implements OnInit {

    currentUser: User;

    //Variables de configuración/mensajes
    appConfig = environment.settings;
    errors: Object = {};
    msgs: Message[] = [];

    //Catálogos
    usuarios: any[];
    filteredUsuarios: any[];
    usuario: any = null;

    loggedActions: LoggedActions[] = [];
    loggedActionsParaExportar: LoggedActions[] = [];
    cols: any[];
    loading: boolean = true;
    @ViewChild('tt') table: Table;
    exportTableName: string;
    desde: Date = new Date();
    hasta: Date = new Date();
    dtRangeMonth: boolean = false;
    dtFilter: any;
    @ViewChild('dt') dt: any;

    exportColumns: any[];
    pdfDescargar: boolean = false;

    procesando: boolean = false;

    //Variables con objeto de edición
    reportes: Reporte[] = [];
    reportesFiltrados: Reporte[] = [];
    reporte: Reporte = new Reporte();

    reporteGenerado: boolean = false;
    mostrarVisualidorReporte: boolean = false;
    reporteURL: any; //Para lanzar el popup de vista previa
    reporteBLOB: any; //Para descargar el reporte

    filtrosData: FiltrosData = new FiltrosData();

    //Inicializar selector PDF-EXCELL
    stateOptions: any[];
    selector: string = 'pdf'
    cargandoDataInit: boolean = false;
    ui: UIService;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private usersService: UsersService,
        private fazilService: FAZILService,
        private administracionService: AdministracionService,
        private auditoriaService: AuditoriaService,
        private uiService: UIService,
        private confirmationService: ConfirmationService,
        private breadcrumbService: BreadcrumbService,
        private messageService: MessageService
    ) {
        this.ui = uiService;
        this.cargarDataConstructor();
    }

    cargarDataConstructor() {
        this.cargandoDataInit = true;
        this.breadcrumbService.setItems([
            { label: 'Auditoria del Sistema', routerLink: ['auditoria/datatable'] }
        ]);
        //Inicializar
        this.exportTableName = "Auditoria";
        let now = new Date();
        this.desde.setDate(now.getDate() - 30);
        this.stateOptions = [{ label: 'PDF', value: 'pdf' }, { label: 'EXCEL', value: 'excel' }];

        this.loading = false;
        this.cols = [
            { field: 'eventId', header: 'Id', visible: true, class: 'col1' },
            { field: 'schemaName', header: 'Esquema', visible: false, class: 'col1' },
            { field: 'tableName', header: 'Tabla/Módulo', visible: true, class: 'col2' },
            { field: 'sessionUserName', header: 'Usuario', visible: false, class: 'col2' },
            { field: 'actionTstampTx', header: 'Fecha de Ejecución', visible: true, class: 'col2' },
            { field: 'action', header: 'Acción', visible: true, class: 'col2' },
            { field: 'rowData', header: 'Dato anterior', visible: true, class: 'col3' },
            { field: 'changedFields', header: 'Datos cambiados', visible: true, class: 'col3' },
        ];

        this.exportColumns = this.cols.filter(col => col.visible == true).map(col => ({ title: col.header, dataKey: col.field }));
    }

    ngOnInit(): void {
        this.userService.currentUser.subscribe(userData => {
            this.currentUser = userData;
            if (this.currentUser && this.currentUser.uuid) {
                this.cargarDataInit();
            }
        });
    }

    async cargarDataInit() {
        this.getUsuarios();
        this.reportes = await this.getReportesPorModuloClase(this.router.url, 'lista');
        if (this.reportes.length == 1) {
            this.reporte = this.reportes[0]; //1er elemento
        }
        this.cargandoDataInit = false;
    }

    public getReportesPorModuloClase(routerLink: string, clase: string): Promise<any> {
        return this.administracionService.getReportesPorModuloClase(routerLink, clase).toPromise();
    }

    exportExcel() {
        import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(this.loggedActions);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            this.saveAsExcelFile(excelBuffer, this.exportTableName);
        });
    }

    saveAsExcelFile(buffer: any, fileName: string): void {
        import("file-saver").then(FileSaver => {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data: Blob = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
        });
    }

    buscarPorUsuarioFechas() {
        this.procesando = true;
        this.ui.limpiarMessages();
        let username = "";
        if (this.usuario) {
            username = this.usuario.username;
        }
        if (username != "" && this.desde != null && this.hasta != null) {
            this.auditoriaService.listarPorUsuarioFechas(username, this.desde, this.hasta).subscribe((data) => {
                this.loggedActions = data;
                if (!this.loggedActions) {
                    this.loggedActions = [];
                }
                this.pdfDescargar = this.loggedActions.length != 0;
                this.procesando = false;
            })
        } else {
            this.loggedActions = [];
            this.pdfDescargar = this.loggedActions.length != 0;
            this.ui.mostrarMensaje("warn", "Detalle la búsqueda, especifique el usuario y un rango de fechas");
            this.procesando = false;
        }
    }

    getUsuarios() {
        this.usersService.listarActivos().subscribe((data) => {
            this.usuarios = data;
            if (!this.usuarios) {
                this.usuarios = [];
            }
        });
    }

    /**
    * Filtrar componente autocompletar
    */
    filtrarUsuarios(event) {
        this.filteredUsuarios = [];
        for (let i = 0; i < this.usuarios.length; i++) {
            let usuario = this.usuarios[i];
            if (
                usuario.name.toLowerCase().indexOf(event.query.toLowerCase()) >= 0
            ) {
                this.filteredUsuarios.push(usuario);
            }
        }
    }

    /**
   **Manejo de filtros
   **/
    onFilterDate(event) {//Aplicar todos los filtros
        if (this.desde && this.hasta) {
            this.desde.setHours(0, 0, 0, 0);
            this.hasta.setHours(23, 59, 59, 59);
        } else if (this.desde) {
            this.desde.setHours(0, 0, 0, 0);
        }
        //        this.buscarPorUsuarioFechas();
    }

    onFilterDateRange(event) {
        if (event) {
            this.desde = null;
            this.hasta = null;
            if (event.checked) {
                this.desde = new Date();
                //                if (new Date().getMonth().valueOf() == 0) {
                //                    this.desde.setFullYear(new Date().getFullYear() - 1, 11, new Date().getDay());
                //                } else {
                this.desde.setMonth(new Date().getMonth() - 1);
                //                }
                this.desde.setHours(0, 0, 0, 0);
                this.hasta = new Date();
                this.hasta.setHours(23, 59, 59, 59);
            } else {
                this.desde = null;//Encerar el rango de fechas
                this.hasta = null;
            }
        }
        //        this.buscarPorUsuarioFechas();
    }

    async limpiarFiltros() {
        this.dtFilter = null;
        this.usuario = null;
        //Un mes atras
        const now = new Date();
        this.desde.setDate(now.getDate() - 30);
        this.hasta = now;
        this.dtRangeMonth = false;
        this.buscarPorUsuarioFechas();
        if (this.dt) {
            this.dt.reset();
        }
    }

    /**
    * Manejo de archivos PDF
    **/
    exportPdf() {
        // const doc = new jsPDF();
        const doc: jsPDF = new jsPDF('l', 'pt');

        const datepipe: DatePipe = new DatePipe('es')
        //Igualar a la tabla visual
        this.loggedActionsParaExportar = [];
        this.loggedActions.forEach(la => {
            let copia = la;
            this.exportColumns.forEach(col => {
                let data = la[col.dataKey]
                if (col.dataKey == 'actionTstampTx') {
                    data = datepipe.transform(data, 'yyyy/MM/dd HH:mm:ss')
                    copia[col.dataKey] = data;
                } else if (col.dataKey == 'action') {
                    copia[col.dataKey] = data == 'I' ? 'CREAR' : 'MODIFICAR';
                }
                this.loggedActionsParaExportar.push(copia);
            })
        });
        //doc['autoTable'](this.exportColumns, this.loggedActionsParaExportar)
        doc['autoTable'](this.exportColumns, this.loggedActions, {
            tableLineColor: [189, 195, 199],
            tableLineWidth: 0.75,
            styles: {
                font: 'Arial',
                lineColor: [44, 62, 80],
                lineWidth: 0.55
            },
            headerStyles: {
                fillColor: [0, 0, 0],
                fontSize: 10
            },
            bodyStyles: {
                fillColor: [216, 216, 216],
                textColor: 50,
                fontSize: 10
            },
            alternateRowStyles: {
                fillColor: [250, 250, 250]
            },
            startY: 100
        });
        doc.setTextColor(0, 0, 0, 0);
        doc.text("Detalle de auditoria del usuario: " + this.usuario['nombre'], 0, 10);
        doc.save("historial_auditoria.pdf");
    }

    /**
    * Manejo de reportes
    */
    async generarReportePorFiltros() {
        this.reporteBLOB = null;
        this.reporteURL = null;
        this.reporteGenerado = false;
        this.mostrarVisualidorReporte = false;
        this.filtrosData.filtros = [];
        this.filtrosData.tipo = this.selector;
        let filtro;
        if (this.desde) {//Cargar el filtro de fechas
            filtro = new FiltroData();
            filtro.token = 'fechaInicial';
            filtro.valor = "" + this.desde;
            filtro.tipo = "Date";
            this.filtrosData.filtros.push(filtro);
            filtro = new FiltroData();
            filtro.token = 'fechaFinal';
            filtro.tipo = "Date";
            if (this.hasta) {
                filtro.valor = "" + this.hasta;
            } else {
                filtro.valor = "" + new Date();
            }
            this.filtrosData.filtros.push(filtro);
        }
        if (this.usuario && this.usuario['id']) {//Cargar el filtro de comando operacional
            filtro = new FiltroData();
            filtro.token = 'usuarioId';
            filtro.valor = "" + this.usuario['id'];
            this.filtrosData.filtros.push(filtro);
        }

        //Solicitar reporte con filtros
        if (this.filtrosData && this.filtrosData.filtros) {

            //Parámetros del reporte
            if (this.reporte.url && this.reporte.url != '') {
                this.procesando = true;
                //Parámetros del reporte

                this.auditoriaService.generarReportePorFiltros(this.reporte.uuid, this.filtrosData).subscribe(
                    (responseBlob: any) => {

                        let blob: any = new Blob([responseBlob], { type: responseBlob.type });

                        if (this.filtrosData.tipo == 'pdf') {
                            const fileReader = new FileReader();
                            fileReader.onload = () => {
                                this.reporteURL = new Uint8Array(fileReader.result as ArrayBuffer);
                                this.reporteGenerado = true;
                                this.mostrarVisualidorReporte = true;
                                this.procesando = false;

                            };
                            if (blob['type'] != '' && blob['size'] != 0) {
                                fileReader.readAsArrayBuffer(blob);
                                this.reporteBLOB = blob;
                            } else {
                                this.reporteGenerado = false;
                                this.mostrarVisualidorReporte = true;
                                this.procesando = false;
                            }
                        } else {
                            this.saveAsEXCELFile(blob, this.reporte.name);
                            this.reporteGenerado = true;
                            this.mostrarVisualidorReporte = false;
                            this.procesando = false;
                        }

                    },
                    (err) => {
                        this.errors = err["errors"];
                        this.messageService.add({
                            severity: "error",
                            summary: this.errors["type"],
                            detail: `${this.errors["message"]}`,
                        });
                    }
                );
            } else {
                this.messageService.add({
                    severity: "error",
                    summary: "Reporte inconsistente",
                    detail: `${this.reporte["nombre"]} no esta correctamente definido. Consulte con el administrador.`,
                });

                this.procesando = false;
            }
        }
    }

    /**
    * Manejo de catálogos, implementar en autocomplete o select
    */
    filtrarReportes(event) {
        let filtered: any[] = [];
        let query = event.query;
        for (let i = 0; i < this.reportes.length; i++) {
            let item = this.reportes[i];
            if (item.name.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                filtered.push(item);
            }
        }
        this.reportesFiltrados = filtered;
    }

    /**
    * Manejo de archivos PDF
    */
    saveAsPDFFile(blob: any, fileName: string): void {
        import("file-saver").then(FileSaver => {
            let ZIP_EXTENSION = '.pdf';
            FileSaver.saveAs(blob, fileName + '_reporte_' + new Date().getTime() + ZIP_EXTENSION);
        });
    }

    /**
    * Manejo de archivos EXCEL
    */
    saveAsEXCELFile(blob: any, fileName: string): void {
        import("file-saver").then(FileSaver => {
            let ZIP_EXTENSION = '.xls';
            FileSaver.saveAs(blob, fileName + '_reporte_' + new Date().getTime() + ZIP_EXTENSION);
        });
    }

    ///////////////////////////////////////////////////////////////////////////
    //Control de acceso a acciones en pantalla
    // TODO: implementar estos métodos en todas las pantallas
    ///////////////////////////////////////////////////////////////////////////
    puedeEjecutar(accion: string): boolean {
        if (!this.currentUser || !this.currentUser.tareas) { //No tiene esta tarea
            return false;
        }

        const routerLink = this.router.url.replace("/fazil/", "");
        let tarea: TareaModel = new TareaModel;
        tarea = this.currentUser.tareas.find(val => routerLink.startsWith(val.routerLink));

        if (!tarea) { //No tiene esta tarea
            return false;
        }
        if (accion == "lectura") {
            return tarea.puedeLeer;
        } else if (accion == "crear") {
            return tarea.puedeCrear;
        } else if (accion == "escritura") {
            return tarea.puedeEscribir;
        } else if (accion == "borrado") {
            return tarea.puedeBorrar;
        } else if (accion == "aprobar") {
            return tarea.puedeAprobar;
        }
        return false;
    }

    /**
    * Descarga el último reporte generado
    */
    descargarReporte() {
        this.saveAsPDFFile(this.reporteBLOB, this.reporte.name);
    }
}